import React, { useState, useEffect } from "react";
import styles from "./Avatar.module.css";

const isDefaultPic = (url) => {
    if (!url || typeof url !== "string") return true;
    const trimmed = url.trim();
    if (trimmed === "" || trimmed === "undefined" || trimmed === "null") return true;
    if (trimmed.includes("user.png")) return true;
    if (trimmed.includes("933-9332131")) return true;
    if (trimmed.includes("profile-picture-default")) return true;
    if (trimmed.includes("default-png.png")) return true;
    return false;
};

const Avatar = ({ src, name, className, onClick, style }) => {
    const isDefault = isDefaultPic(src);
    
    const [imgError, setImgError] = useState(false);
    const [useFallback, setUseFallback] = useState(isDefault);

    useEffect(() => {
        setImgError(false);
        setUseFallback(isDefaultPic(src));
    }, [src]);

    const getInitials = () => {
        if (!name) return "?";
        const parts = name.trim().split(/\s+/);
        if (parts.length > 1) {
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }
        return name.charAt(0).toUpperCase();
    };

    const getBackgroundColor = () => {
        const colors = [
            "#A6539D", // Theme Purple
            "#3A0DBB", // Theme Blue
            "#FF5733", // Coral
            "#33FF57", // Green
            "#3357FF", // Blue
            "#F333FF", // Pink
            "#33FFF6", // Cyan
            "#FFB533", // Orange
            "#5D3A0D"  // Brown
        ];
        
        let hash = 0;
        const str = name || "User";
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    if (useFallback || imgError) {
        return (
            <div 
                className={`${styles.avatarFallback} ${className}`}
                style={{ backgroundColor: getBackgroundColor(), ...style }}
                onClick={onClick}
                title={name}
            >
                {getInitials()}
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name || "Profile"}
            className={`${styles.avatarImage} ${className || ""}`}
            style={style}
            referrerPolicy="no-referrer"
            onError={() => setImgError(true)}
            onClick={onClick}
        />
    );
};

export default Avatar;


